import { EventDuration } from "../types";

export const durationToHeight = (duration: EventDuration) => {
  const size = duration / 15;
  const pxHeight = size * 28;

  return pxHeight;
};
